// @spec GHG-STR-045
'use client';

import { useOrganization } from '@clerk/clerk-react';
import { createFileRoute } from '@tanstack/react-router';

import { Skeleton } from '@/components/ui/skeleton';
import { useGHGOrganizationId } from '@/features/ghg/api/use-ghg-organization-id';
import { GapAnalysisDashboard } from '@/features/ghg/components/GapAnalysisDashboard';
import { useGHGPagePeriod } from '@/features/ghg/hooks/use-ghg-page-period';
import i18n from '@/lib/i18n';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/_authenticated/ghg/gap-analysis')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.gapAnalysis'),
  }),
  component: GapAnalysisPage,
});

function GapAnalysisPage() {
  const { t } = useTranslation('ghg');
  const { isLoaded: isOrgLoaded } = useOrganization();
  const orgId = useGHGOrganizationId();
  const { periodId } = useGHGPagePeriod();

  if (!isOrgLoaded || !orgId) {
    return (
      <div className="p-8">
        <div className="mx-auto max-w-7xl space-y-6">
          <Skeleton className="h-9 w-48" />
          <Skeleton className="h-5 w-80" />
          <Skeleton className="h-96 w-full" />
        </div>
      </div>
    );
  }

  return (
    <div className="p-8">
      <div className="mx-auto max-w-7xl space-y-6">
        <header className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h1 className="text-3xl font-semibold text-foreground">{t('gapAnalysisPage.heading')}</h1>
            <p className="mt-1 text-muted-foreground">
              {t('gapAnalysisPage.description')}
            </p>
          </div>
        </header>

        <GapAnalysisDashboard reportingPeriodId={periodId} />
      </div>
    </div>
  );
}
